import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Loading } from '@element-plus/icons'


export default /*@__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    type: { default: 'fullHeight' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'loader-container',
      { 'full-height-container': _ctx.type === 'fullHeight' },
      { 'offset-container': _ctx.type === 'offset' },
    ])
  }, [
    _createVNode(_component_el_icon, {
      size: 30,
      class: "is-loading"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading))
      ]),
      _: 1
    })
  ], 2))
}
}

})